import React, { useState, useCallback, useEffect } from "react";
import {
  BiCheckCircle,
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
} from "react-icons/bi";
import {
  BsArrow90DegRight,
  BsArrowRight,
  BsFillCheckCircleFill,
  BsFillXCircleFill,
} from "react-icons/bs";
import ViewSummaryCommon from "../../../components/Trivvy/ViewSummarycomon";

import ReactTooltip from "react-tooltip";
import {
  applyCustomFontStyles,
  noScoreTrivvy,
  resolveTrivvyCopy,
  THEME_SETTING,
} from "../data";
import debounce from "lodash.debounce";
import parse from "html-react-parser";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { baseUrl, contvertHTMLToPlain } from "../../../utils/constants";
import moment from "moment";
import { GiOpenTreasureChest } from "react-icons/gi";
import ShareEntity from "../../../components/ShareEntity/ShareEntity";
import StarRatings from "react-star-ratings";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import { setCurrentQuiz } from "../../../modules/actions";
import ReminderComponent from "../Components/ReminderComponent";
import WrapLinkedRewards from "../Components/WrapLinkedRewards";
import { getTextFromLanguageCodeAndKey } from "../languages";
import "./ending-results-ds.css";

export default function TriviaEndingBlock({
  endingData,
  view,
  themeSettings,
  // quizResult,
  quizResponses,
  shareUrl,
  privacy,
  isMobileView,
  questions,
  currentQuizLinkedRewards,
  quizResultObjectId,
  previewOnly,
  quizData,
  setCurrentQuiz,
  isLastAttempt,
  demoPreview,
  source,
  customText,
  setTrivvyRatingSubmitted,
  ratingSubmitted,
  quizExternalUserData,
  trivvyLanguage,
  ...props
}) {
  const isMobile = isMobileView;

  const [starRating, setStarRating] = useState(quizData.rating || 0);
  const [percentCorrect, setPercentCorrect] = useState(null);

  var handleSourceClick = function(e) {
    e.preventDefault();
    const profileUser = props.user && props.user.profile ? props.user.profile._id : false;
    var isLoggedIn = props.user && (props.user._id || !!profileUser);
    var triviaId = quizData && quizData._id;
    var signedUrlEndpoint = isLoggedIn ? url.getSignedUrl : url.publicGetSignedUrl;
    if (triviaId) {
      axios.get(signedUrlEndpoint, {
        params: { id: triviaId, model: 'TriviaTemplate', inline: 1 }
      }).then(function(res) {
        var signedUrl = res.data && res.data.url;
        if (signedUrl) {
          window.open(signedUrl, '_blank');
        } else {
          window.open(source, '_blank');
        }
      }).catch(function() {
        window.open(source, '_blank');
      });
    }
  };
  const copySurveyUrl = () => {
    window.navigator.clipboard.writeText(shareUrl);
  };
  const [quizResult, setQuizResult] = useState({
    total: 0,
    correct: 0,
    wrong: 0,
  });

  const showRatingPage =
    quizData && quizData.ratingPage && quizData.ratingPage.display;

  const [quizTableData, setQuizTableData] = useState([]);
  // const [isAnswerExist, setAnswerExists] = useState(false)
    // = quizTableData.some(obj => obj.is_correct === true);

  const [comment, setComment] = useState("");
  const [customTextModal, setCustomTextModal] = useState(false);
  const [submitRatingLoading, setSubmitRatingLoading] = useState(false);

  const [hideCorrectAnswerColumn, setHideCorrectAnswerColumn] = useState(false);

  const toParseableString = (value, fallback = "") => {
    if (value === null || value === undefined) return fallback;
    if (typeof value === "string") return value;
    if (typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }

    try {
      const stringified = JSON.stringify(value);
      return typeof stringified == "string" ? stringified : fallback;
    } catch (err) {
      return fallback;
    }
  };

  const getAnswerText = (questionRes) => {
    const selectedAnswer = questionRes && questionRes.selectedAnswer;

    if (!selectedAnswer) return "No Response";

    if (Array.isArray(selectedAnswer)) {
      const selectedTexts = selectedAnswer
        .map((answer) => toParseableString(answer && answer.text))
        .filter(Boolean);

      return selectedTexts.length ? selectedTexts.join(", ") : "No Response";
    }

    if (typeof selectedAnswer == "string") return selectedAnswer;

    return toParseableString(selectedAnswer.text, "No Response");
  };

  const getCorrectOptionText = (question) => {
    if (!["MCQ", "CHECKBOX"].includes(question.question_type)) return "NA";

    const correctOptions = Array.isArray(question.correct_options)
      ? question.correct_options
      : [];

    const correctOptionTexts = correctOptions
      .map((option) => toParseableString(option && option.text))
      .filter(Boolean);

    return correctOptionTexts.length ? correctOptionTexts.join(", ") : "NA";
  };

  const areCheckboxAnswersCorrect = (selectedAnswer, correctOptions) => {
    if (!Array.isArray(selectedAnswer) || !Array.isArray(correctOptions)) {
      return false;
    }

    const selectedOptionIds = selectedAnswer
      .map((answer) => answer && answer.option_id)
      .filter(Boolean)
      .sort();

    const correctOptionIds = correctOptions
      .map((answer) => answer && answer.option_id)
      .filter(Boolean)
      .sort();

    if (selectedOptionIds.length !== correctOptionIds.length) return false;

    return selectedOptionIds.every(
      (optionId, index) => optionId == correctOptionIds[index]
    );
  };

  const getIsCorrect = (question, questionRes) => {
    if (!questionRes || !questionRes.selectedAnswer) return false;

    if (question.question_type == "CHECKBOX") {
      return areCheckboxAnswersCorrect(
        questionRes.selectedAnswer,
        question.correct_options
      );
    }

    if (question.question_type == "MCQ") {
      return question.correct_options &&
        question.correct_options[0] &&
        questionRes.selectedAnswer
        ? questionRes.selectedAnswer.option_id == question.correct_options[0].option_id
        : false;
    }

    return false;
  };

  useEffect(() => {

    console.log('97 --- ',questions)
    console.log('98 --- ',quizResponses)

    if (questions && quizResponses) {
      let totalCorrect = 0,
        totalWrong = 0;
      for (const response of quizResponses) {
        if (
          response.selectedAnswer &&
          response.question.correct_options &&
          response.question.correct_options.find(
            (x) => x.option_id ===  response.selectedAnswer.option_id
          )
        ) {
          totalCorrect += 1;
        } else {
          if (response.question_type == "MCQ") {
            totalWrong += 1;
          }
        }
      }

      const q_res_arr = [];

      for (const question of questions) {
        const question_id = question.question_id;
        const question_text = toParseableString(question.question_text);
        const questionRes = quizResponses.find(
          (x) => x.question && x.question.question_id == question.question_id
        );
        const answer_text = getAnswerText(questionRes);
        const correct_option_text = getCorrectOptionText(question);
        const is_correct = getIsCorrect(question, questionRes);

        q_res_arr.push({
          question_id,
          question_text,
          answer_text,
          correct_option_text,
          is_correct,
          question_type: question.question_type,
        });
      }

      setQuizTableData(q_res_arr);

      const resStateObj = noScoreTrivvy(quizData)? {total:0,correct:0,wrong:0}: {
        total: questions.filter((x) => x.question_type == "MCQ").length,
        correct: totalCorrect,
        wrong: totalWrong,
      };

      setQuizResult({ ...resStateObj });

      if (resStateObj.total > 0) {
        setPercentCorrect(
          parseFloat((resStateObj.correct / resStateObj.total) * 100).toFixed(2)
        );
      }
    }
  }, [quizResponses]);

  useEffect(() => {
    if(!noScoreTrivvy(quizData)){
      if (demoPreview || previewOnly) {
      } else {
        if (quizResult.total && quizData) {
          if (quizData.allowAttempts > 0) {
            if (isLastAttempt) {
              setHideCorrectAnswerColumn(false);
            } else if (quizResult.total == quizResult.correct) {
              setHideCorrectAnswerColumn(false);
            } else if (quizData.allowAttempts == 2) {
              if (
                percentCorrect != null &&
                quizData &&
                quizData.minimumPassingPercent &&
                quizData.minimumPassingPercent != null &&
                quizData.minimumPassingPercent > 0
              ) {
                if (percentCorrect >= quizData.minimumPassingPercent) {
                  setHideCorrectAnswerColumn(false);
                } else {
                  setHideCorrectAnswerColumn(true);
                }
              } else {
                setHideCorrectAnswerColumn(true);
              }
            } else {
              setHideCorrectAnswerColumn(true);
            }
          }
        }
      }
    }else{
      setHideCorrectAnswerColumn(true);
    }
   
  }, [quizResult, percentCorrect]);

  let single_reward = [];

  single_reward =
    currentQuizLinkedRewards && currentQuizLinkedRewards.length > 0
      ? currentQuizLinkedRewards[0]
      : null;

  console.log("currentQuizLinkedRewards----- ", currentQuizLinkedRewards);

  console.log("single_reward ---- ", single_reward);

  const quizShareObject = quizData
    ? {
        triviaName: quizData.name,
        createdBy: quizData.createdBy ? quizData.createdBy.firstName : "",
        totalQuestions: questions.filter((x) => x.question_type == "MCQ")
          .length,
        totalCorrect: quizResult.correct,
        totalWrong: quizResult.wrong,
        correctPercent: Math.round(
          (quizResult.correct / questions.length) * 100
        ),
        timeTaken: props.timeTaken,
        triviaLink: window.location.href.replace("result", "start"),
      }
    : {};

  const isMcqTrivvy =
    quizData &&
    quizData.questions &&
    quizData.questions.filter((x) => x.question_type == "MCQ").length > 0
      ? true
      : false;


    const isAnyCorrectAnswerTrivvy =  quizData &&
    quizData.questions &&
    quizData.questions.filter((x) => x.correct_options && x.correct_options[0] && x.correct_options[0]).length > 0

  // Capitalized only when the sentence starts cold (no firstName prefix ahead of it) -
  // e.g. an anonymous Copy Link view.
  const getAnswerResultText = () => {
    const text = getTextFromLanguageCodeAndKey(trivvyLanguage, "answerResultEndingPage")
      .replace("{{@}}", quizResult.correct)
      .replace("{{@@}}", quizResult.total)
    const hasNamePrefix = !!(props.user && props.user.profile && props.user.profile.firstName)
    if (hasNamePrefix) {
      return text
    }
    return text.charAt(0).toUpperCase() + text.slice(1)
  }


  
  


  const remindMeData =
    quizTableData && quizTableData.length
      ? quizTableData.filter(x => x.question_type =="MCQ" && x.correct_option_text !="No Answer"  ).map((doc, index) => ({
          label: contvertHTMLToPlain(doc.question_text),
          q_id: doc.question_id,
          value: index,
          correctOption: contvertHTMLToPlain(
            doc.correct_option_text ? doc.correct_option_text : "NA" || "NA"
          ),
          answer: doc.answer_text
            ? contvertHTMLToPlain(doc.answer_text || "No Answer")
            : "No Answer",
        }))
      : [];

  const getAvailableData = (object) => {
    let str = "";
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        str = element;
      }
    }
    return str || "Dear user";
  };



  return (
    <div
      className="ds-ending-results"
      style={{ flex: 1,...applyCustomFontStyles(themeSettings) }}
    >
      <div>
        <div
          className="trivia-survey-edit-questions-ui_question_title"
          style={{ paddingTop: isMobile ? "20%" : "2%" }}
        >
          <span
            className={
              isMobile
                ? "edit_survey_question_wrapper_noborder_mobile text-center ds-ending-heading"
                : "edit_survey_question_wrapper_noborder text-center ds-ending-heading"
            }
            style={{
              width: "100%",
              // marginTop:isMobile?"50px":"2px"
              ...(demoPreview || previewOnly
                ? {
                    marginTop: "30px",
                  }
                : {}),
            }}
          >
            {parse(
              resolveTrivvyCopy(
                endingData.heading,
                "thanksForYourTime",
                trivvyLanguage
              ) || "<p></p>"
            )}
          </span>
        </div>

        {demoPreview || previewOnly ? 
        null : (
          <div className="">
            <div
              className={"mt-4 mb-3 text-center"}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
             {((quizResult&& quizResult.total > 0 && quizResult.correct) || (source && source.length) ||  (customText && customText.length && !quizData.isBuiltInWithAiType))?
               <div
                style={{
                  width: "100%",
                  color:
                    themeSettings && themeSettings.quizTextColor
                      ? themeSettings.quizTextColor
                      : "white",
                  marginLeft: "10%",
                  marginRight: "10%",
                }}
                className={"trivvy-result-card-wrapper"}
              >
                <div className="text-left">
                  {quizResult.total > 0 && (
                    <span>
                      {props.user && props.user.profile && props.user.profile.firstName
                        ? props.user.profile.firstName +", "
                        : ""}
                        { isAnyCorrectAnswerTrivvy  && getAnswerResultText()}
                      
                    </span>
                  )}
                  {source && source.length ? (
                    <span>
                      {" "}
                      <a
                        href="#"
                        onClick={handleSourceClick}
                        style={{ cursor: 'pointer' }}
                      >
                        ({getTextFromLanguageCodeAndKey(trivvyLanguage,"sourceLink")})
                      </a>
                    </span>
                  ) : customText && customText.length && !quizData.isBuiltInWithAiType ? (
                    <span>
                      {" "}
                      <b
                        style={{ textDecoration: "underline" }}
                        className="cursor-pointer text-info"
                        onClick={() => setCustomTextModal(true)}
                      >
                        ({getTextFromLanguageCodeAndKey(trivvyLanguage,"sourceText")})
                      </b>
                    </span>
                  ) : (
                    ""
                  )}
                   {/* {getTextFromLanguageCodeAndKey(trivvyLanguage,"youCan")}
                  <ShareEntity
                    noMainClass
                    noSlackTeams={props.user ? false : true}
                    comp={<span className="trivvy-linktext">{getTextFromLanguageCodeAndKey(trivvyLanguage,"shareTrivvy")}</span>}
                    user={props.user}
                    entityType="TRIVVY"
                    display="POPPER"
                    item={{ ...quizShareObject }}
                    customClassName="cursor-pointer"
                  /> */}
                 {/* {getTextFromLanguageCodeAndKey(trivvyLanguage,"orReturnTo")}{" "} */}
                  {/* <span
                    className="trivvy-linktext cursor-pointer ml-1"
                    onClick={() =>
                      props.history.push(
                        `/home/${props.user.profile.organizationId._id}/profile/${props.user.profile._id}/my-trivvys`
                      )
                    }
                  >
                    {getTextFromLanguageCodeAndKey(trivvyLanguage,"myTrivvys")}
                  </span> */}
                
                </div>

                <div className="mt-2">
                  {
                  isAnyCorrectAnswerTrivvy &&  remindMeData && remindMeData.length > 0 && <ReminderComponent
                    trivia={quizData}
                    resultId={quizResultObjectId}
                    remindMeDdData={remindMeData}
                    planType={quizData.orgPlan}
                    externalUser={
                      props.user && props.user.profile && props.user.profile._id
                        ? false
                        : true
                    }
                    btnText={getTextFromLanguageCodeAndKey(trivvyLanguage,"reinforceButton")}
                  />
                  }

                  {
                    quizData.librarySummaryText && <ViewSummaryCommon btnText={getTextFromLanguageCodeAndKey(trivvyLanguage,"viewSummary")} summaryText={quizData.librarySummaryText} />
                  }
                
                </div>
              </div>
                : null}
            </div>

            <div
              className={"text-center ds-ending-passfail"}
              style={{
                // color: "white",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: isMobile ? "90%" : "70%",
                }}
              >
                {percentCorrect != null &&
                quizData &&
                quizData.minimumPassingPercent &&
                quizData.minimumPassingPercent != null &&
                quizData.minimumPassingPercent > 0 ? (
                  <div className="mt-4 mb-3">
                    {percentCorrect >= quizData.minimumPassingPercent ? (
                      <span>
                        {getTextFromLanguageCodeAndKey(trivvyLanguage,"endingPassingPerMessage1")}{" "}
                        {quizData.minimumPassingPercent} % {getTextFromLanguageCodeAndKey(trivvyLanguage,"endingPassingPerMessage2")}{" "}
                        {Math.round(percentCorrect)} %. {getTextFromLanguageCodeAndKey(trivvyLanguage,"niceJob")}!
                      </span>
                    ) : (
                      <span>
                        {getTextFromLanguageCodeAndKey(trivvyLanguage,"endingNoPassMessage1")}{" "}
                        {quizData.minimumPassingPercent} %. {getTextFromLanguageCodeAndKey(trivvyLanguage,"endingNoPassMessage2")}{" "}
                        {Math.round(percentCorrect)} %. {getTextFromLanguageCodeAndKey(trivvyLanguage,"endingNoPassMessage3")}. (
                        <b
                          className="cursor-pointer"
                          onClick={() => {
                            const url = window.location.href.replace(
                              "/result",
                              "/start"
                            );
                            window.location.href = url;
                          }}
                        >
                          {getTextFromLanguageCodeAndKey(trivvyLanguage,"clickHere")}
                        </b>{" "}
                        {getTextFromLanguageCodeAndKey(trivvyLanguage,"toRetake")})
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <Modal isOpen={customTextModal}>
              <ModalHeader
                className="trivia_modal_header_bg"
                toggle={() => setCustomTextModal(false)}
              >
                {getTextFromLanguageCodeAndKey(trivvyLanguage,"customText")}
              </ModalHeader>
              <ModalBody className="p-3">{customText}</ModalBody>
            </Modal>

            <div
              style={{
                marginLeft: isMobile ? "4%" : "10%",
                marginRight: isMobile ? "4%" : "10%",
              }}
              className="border border-gray trivia-single-results-summary-tbl"
            >
              <div className="table-responsive">
              
                <Table className={`mb-0 take-trivvy-result-page-table ${noScoreTrivvy(quizData)?"no-show-rw-clr":""}`}>
                  <thead>
                    {isMobile ? (
                      <tr className="ans-correct-bg">
                        <th style={{ minWidth: "200px", maxWidth: "200px" }}>
                        {getTextFromLanguageCodeAndKey(trivvyLanguage,"question")}
                        </th>
                        <th style={{ minWidth: "150px", maxWidth: "150px" }}>
                        {getTextFromLanguageCodeAndKey(trivvyLanguage,"yourAnswer")}
                        </th>
                        {!hideCorrectAnswerColumn && isAnyCorrectAnswerTrivvy && (
                          <th style={{ minWidth: "150px", maxWidth: "150px" }}>
                           {getTextFromLanguageCodeAndKey(trivvyLanguage,"correctAnswer")}
                          </th>
                        )}

                        <th style={{ minWidth: "25px", maxWidth: "25px" }}></th>
                      </tr>
                    ) : (
                      <tr className="ans-correct-bg">
                        <th style={{ width: "40%" }}>  {getTextFromLanguageCodeAndKey(trivvyLanguage,"question")}</th>
                        <th style={{ width: "25%" }}>   {getTextFromLanguageCodeAndKey(trivvyLanguage,"yourAnswer")}</th>
                        {!hideCorrectAnswerColumn && isAnyCorrectAnswerTrivvy && (
                          <th style={{ width: "30%" }}>{getTextFromLanguageCodeAndKey(trivvyLanguage,"correctAnswer")}</th>
                        )}
                        <th style={{ width: "5%" }}></th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {quizTableData.map((resp) => {
                      console.log({resp})
                      const isAnswerExist = !["No Answer","NA"].includes(resp.correct_option_text)
                      if (isMobile) {
                        return (
                          <tr>
                            <td
                              style={{ minWidth: "200px", maxWidth: "200px" }}
                            >
                              {parse(toParseableString(resp.question_text))}
                            </td>
                            <td
                              style={{ minWidth: "150px", maxWidth: "150px" }}
                              className={
                                isAnswerExist?
                                  resp.question_type == "MCQ"  ? 
                                    resp.is_correct ? 
                                      "ans-correct-bg"
                                      : "ans-wrong-bg"
                                  : ""
                                :""
                              }
                            >
                              <span>{parse(toParseableString(resp.answer_text))}</span>
                            </td>
                            {!hideCorrectAnswerColumn && isAnyCorrectAnswerTrivvy && (
                              <td
                                style={{ minWidth: "150px", maxWidth: "150px" }}
                              >
                                <span> {parse(toParseableString(resp.correct_option_text))} </span>
                              </td>
                            )}

                            <td style={{ minWidth: "25px", maxWidth: "25px" }}>
                            {
                                isAnswerExist &&  <div>
                                { 
                                resp.question_type == "MCQ" && (
                                  <div className="correct-mark">
                                    {" "}
                                    {resp.is_correct ? (
                                      <BsFillCheckCircleFill
                                        color={"green"}
                                        size={25}
                                      />
                                    ) : (
                                      <BsFillXCircleFill
                                        color={"red"}
                                        size={25}
                                      />
                                    )}{" "}
                                </div>
                                
                                 
                                )}
                                 </div>
                              }
                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr>
                             
                            <td style={{ width: "40%" }}>
                              {parse(toParseableString(resp.question_text))}
                            </td>
                            <td
                              style={{ width: "25%" }}
                              className={
                                isAnswerExist?
                                resp.question_type == "MCQ"
                                  ? resp.is_correct
                                    ? "ans-correct-bg"
                                    : "ans-wrong-bg"
                                  : ""
                                  : ""
                              }
                            >
                              <div>
                                <span>{parse(toParseableString(resp.answer_text))}</span>
                              </div>
                            </td>
                            {!hideCorrectAnswerColumn && isAnyCorrectAnswerTrivvy && (
                              <td style={{ width: "30%" }}>
                                <span> {parse(toParseableString(resp.correct_option_text))} </span>
                              </td>
                            )}

                            <td style={{ width: "5%" }}>
                              {
                                isAnswerExist &&  <div>
                                { 
                                resp.question_type == "MCQ" && (
                                  <div className="correct-mark">
                                    {" "}
                                    {resp.is_correct ? (
                                      <BsFillCheckCircleFill
                                        color={"green"}
                                        size={25}
                                      />
                                    ) : (
                                      <BsFillXCircleFill
                                        color={"red"}
                                        size={25}
                                      />
                                    )}{" "}
                                </div>
                                
                                 
                                )}
                                 </div>
                              }
                             
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </Table>
              </div>
            </div>

            {/* {currentQuizLinkedRewards && currentQuizLinkedRewards.length ? (
            <div
              className="my-4"
              style={{
                width: isMobile?"100%": "40%",
                margin: "auto",
                padding: "8px",
                backgroundColor: themeSettings.quizBackgroundColor
                  ? themeSettings.quizBackgroundColor
                  : "white",
                color: themeSettings.quizTextColor
                  ? themeSettings.quizTextColor
                  : "black",
              }}
            >
              <h5 className="mb-3">These are the rewards associated with this trivvy</h5>
              <WrapLinkedRewards
                quizPage={demoPreview ? false : true}
                rewards={currentQuizLinkedRewards}
                showLinkedTrivvys
                currentTrivvy={quizData}
              />
            </div>
          ) : (
            ""
          )} */}
          </div>
        )}
      </div>
    </div>
  );
}
